import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

const DEFAULT_META = {
  title: "Riches Media Digital",
  description: "#1 Digital marketing company",
  keywords: "Digital Marketing",
};

const getSeoData = () => {
  const seoElement = document.getElementById("riches-seo-data");

  if (!seoElement?.textContent) {
    return {};
  }

  try {
    return JSON.parse(seoElement.textContent);
  } catch {
    return {};
  }
};

const normalizeKeywords = (keywords) => {
  if (Array.isArray(keywords)) {
    return keywords.join(", ");
  }

  return keywords || DEFAULT_META.keywords;
};

const setMetaContent = (name, content) => {
  const meta = document.querySelector(`meta[name="${name}"]`);

  if (meta) {
    meta.setAttribute("content", content);
  }
};

const setCanonicalUrl = (pathname) => {
  const canonical = document.querySelector('link[rel="canonical"]');

  if (canonical) {
    canonical.setAttribute(
      "href",
      `https://www.richesmediadigital.com${pathname}`
    );
  }
};

const PageMetadata = () => {
  const location = useLocation();
  const seoData = useMemo(getSeoData, []);

  useEffect(() => {
    const pathKey = location.pathname.replace(/^\/+|\/+$/g, "");
    const meta = seoData[pathKey] || DEFAULT_META;

    document.title = meta.title || DEFAULT_META.title;
    setMetaContent("description", meta.description || DEFAULT_META.description);
    setMetaContent("keywords", normalizeKeywords(meta.keywords));
    setCanonicalUrl(location.pathname);
  }, [location.pathname, seoData]);

  return null;
};

export default PageMetadata;
